export function downloadBlob(fileName: string, blob: Blob): void {
  const objectUrl: string = URL.createObjectURL(blob);
  const a = document.createElement('a');

  a.href = objectUrl;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();

  document.body.removeChild(a);
  URL.revokeObjectURL(objectUrl);
}
